/**
 * iOS 17+ Safari: an "ambient" session mixes with the player's own audio and follows the silent switch, as a game's
 * sound effects should (the default "auto" can take over playback like a media app).
 */
export function preferAmbientSession(): void {
  const session = (navigator as unknown as { audioSession?: { type: string } }).audioSession;
  if (!session) return;
  try { session.type = "ambient"; } catch { /* read-only in this browser */ }
}
